<template>
    <div id="step_component_wrapper">
        <clip-loader :loading="loading" :color="'rgb(93, 197, 150)'" size="56px"></clip-loader>
        <div v-if="!loading" class="slot-content" style="max-height: 50vh; padding: 0px; overflow-y: auto; margin: 12px;">
          <dyn-table :array.sync="list" :configs="tableConfigs" :name="tableConfigs.name" :rowClicked="onRowClicked" :focus="selected" :removeDecorations="true" @dynTableReady="getDynTableElement"></dyn-table>
        </div>
        <div v-if="!loading"  class="slot-button">
            <button v-if="!backTo1Allowed" class="btn btn-danger" @click="$root.logout()">{{$Jed.firstUpperTranslate('logout', null)}}</button>
            <button v-else class="btn btn-danger" @click="$emit('backward')">{{$Jed.firstUpperTranslate('back', null)}}</button>

            <button v-if="showSub" class="btn btn-primary-default" @click="loadSub" style="width: auto;">
                {{$Jed.firstUpperTranslate('load', null) + " " + $Jed.translate('model', null)}}
            </button>

            <button v-if="step7" class="btn btn-primary-default" @click="forward" style="width: auto;" :disabled="selected == null">
                {{$Jed.firstUpperTranslate('confirm', null)}}
            </button>

            <button v-if="!step7" class="btn btn-success" @click="load" :disabled="selected == null">
                {{$Jed.firstUpperTranslate('load', null)}}
            </button>
        </div>
    </div>  
</template>
<script>

import vSelect from "../../dynamic/vueSelectWrapper/components/Select.vue";
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import DynTable from "../../dynamic/DynTable.vue";
import utils from '../../../../utils/utilities.js'
import { eventBus } from "../../../eventbus";

export default {
  props: {
    backTo1Allowed: {
      type: Boolean,
      default: false
    },
    isAfterLogin: {
      type: Boolean,
      default: false
    },
    exOnOpen: {
      type: Boolean,
      default: false
    }
  },
  mounted: function() {

    var vm = this,
        idb = this.$root.dataReferences,
        catalogs_list = idb.getCollection('catalogs'),
        sortedCatalogs = catalogs_list.chain().find().compoundsort(['brand','name']).data();
    
    this.selected = this.$store.getters.getSelCat ? this.$store.getters.getSelCat.id.toString() : null
    this.catName = this.$store.getters.getSelCat ? this.$store.getters.getSelCat.name : ''

    //Se prima di selezione catalogo, sono passato da selezione cliente (e ne ho selezionato uno), 
    //devo prendere i cataloghi del cliente selezionato e metterli in indexedDb al posto di quelli che ho inserito quando ho creato indexedDB in App.vue
    var waitForAgentCatalogList = new Promise(function(resolve, reject) { 
      if(vm.$root.clientSelected != null){ 
        
        vm.$root
        .microservice({
            role: "authentication",
            cmd: "GetCatalogList",
            params: {
                idAgente: vm.$Configs.idAgente,
                idCliente: vm.$root.clientSelected  
            }
        })
        .then(response => {
          console.log('SelezioneCatalogo - GetCatalogList of client: ', vm.$root.clientSelected, ', agent: ', vm.$Configs.idAgente, response.body.length)
            var catalogs = response.body;
            // svuoto la collection dei cataloghi in modo da andarla a popolare solo con i cataloghi nuovi appena tornati con la GetCatalogList
            catalogs_list.clear()
            vm.$Configs.catalogs = []
            sortedCatalogs = []
            for(var i=0; i<catalogs.length; i++){
            
                //__________________________________________________________________________________________________________________
                //tra le traduzioni delle descrizioni dei cataloghi utilizzo quella che corrisponde alla lingua corrente
                var traduzioni = catalogs[i].name.trad, 
                    current_lang,
                    filtered = [],
                    traduzioneIta = catalogs[i].name.des;

                current_lang = vm.$root.token.siglaLingua;

                if(traduzioni && traduzioni.length>0 && current_lang != 'ITA'){
                    filtered = traduzioni.filter((t)=>{
                        return t.lid == current_lang
                    })
                }
                //__________________________________________________________________________________________________________________
                var catalog = {
                    id: catalogs[i].id,
                    version: catalogs[i].version,
                    date: new Date(catalogs[i].date).toLocaleDateString(),
                    brand : catalogs[i].brand,
                    name: filtered.length>0 ? filtered[0].des : traduzioneIta,
                    note: vm.$Behaviors.searchCatalogByNotes ? catalogs[i].name.not : "",
                    file: catalogs[i].file
                }

                var catalogToToken = {
                    id: catalogs[i].id,
                    version: catalogs[i].version,
                    date: new Date(catalogs[i].date).toLocaleDateString(),
                    brand : catalogs[i].brand,
                    name: catalogs[i].name,
                    note: vm.$Behaviors.searchCatalogByNotes ? catalogs[i].name.not : "",
                    file: catalogs[i].file
                }

                //inserimento lista dei cataloghi nella collection catalogs dell'indexedDb
                catalogs_list.insert(catalog)
                sortedCatalogs = catalogs_list.chain().find().compoundsort(['brand','name']).data()

                //inserimento lista dei cataloghi nel token
                vm.$Configs.catalogs.push(catalogToToken)
            }
            resolve();
        })
        .catch(err => {
          console.log(err);
          var msg = err && err.body && err.body.error ? err.body.error : ''
          eventBus.$emit('alert', {
            message: "Application caught an error <br> <h5>Details: " + "authentication.GetCatalogList - " + msg +'</h5>',
            type: "error",
            action: ''
          })
        });
      } else {
        resolve()
      }
    }).then(() => {
      // segnalo se esiste solo un catalogo, e da behavior ho stabilito di caricarlo immediatamente
      var loadIfOne = vm.$Behaviors.loadCatalogIfOne && sortedCatalogs.length == 1; //(this.$Behaviors.loadFirstCatalog || loadIfOne)
      // this.$root.openModalSelect necessario, altrimenti emetterei un got Index ulteriore anche quando non avrei bisogno di ricaricare il catalogo
      // anche isAfterLogin necessario, così son certo di caricare immediatamente il catalogo solo all'apertura del modal post login
      if((vm.$Behaviors.loadFirstCatalog || loadIfOne) && vm.$root.openModalSelect && sortedCatalogs.length > 0 && vm.isAfterLogin){
        vm.selected = sortedCatalogs[0].id.toString();
        vm.fileName = sortedCatalogs[0].file;
        vm.catName = sortedCatalogs[0].name
        vm.catBrand = sortedCatalogs[0].brand
        vm.initStep(sortedCatalogs);

        // IMPOSTO VALIDITA' DI DEFAULT
        if(vm.$Behaviors.updatesReference == "date"){
            // set validity as today (session storage salvato a parte)
            vm.$root.validity = new Date()
        }

        vm.load();
      }else{
        
        vm.initStep(sortedCatalogs);
        $("#m-wrap > .sweet-modal-overlay").css("visibility", "initial");
        vm.$emit("tryOpenModal")
        if(vm.exOnOpen){
          vm.manuallyOpenedCallback();
        }
      }
    });
    
    this.$emit("manuallyOpenCallback", {component: "SelezioneCatalogo", callback: this.manuallyOpenedCallback});
  },
  components: {
    vSelect,
    ClipLoader,
    DynTable
  },
  data: function() {
    return {
      list: [],
      loading: true,
      selected: null,
      step7: !this.$Behaviors.machineIdMustExists && this.$Behaviors.updatesReference != 'serial' && this.$Behaviors.requestUpdateReference,

      tableConfigs: {
        name: "TabellaCataloghi",
        visible: true,
        highlighting_parameter: "id",
        ID: "catalogsTable",
        columns: {
          brand: {
            name: "brand",
            position: 1,
            visible: true,
            editable: false,
            width: 20
          },
          name: {
            name: "name",
            position: 2,
            visible: true,
            editable: false,
            width: 45
          },
          version: {
            name: "version",
            position: 3,
            visible: true,
            editable: false,
            width: 15
          },
          date: {
            name: "date",
            position: 4,
            visible: true,
            editable: false,
            width: 20
          },
          note: {
            name: "note",
            position: 5,
            visible: false,
            editable: false,
            width: 1
          }
        }
      },
      catName: null,
      catBrand: null,
      fileName: ""
    };
  },
  computed: {
    showSub: function() {
      // se l'inserimento compatibilità (validità) è abilitato, obbligatorio e per matricola, la selezione modello non viene proposta, in quanto in ogni caso caricherò la matricola selezionata
      return this.$Behaviors.chooseRootNode && this.selected != null && !(!this.$Behaviors.machineIdMustExists && this.$Behaviors.requestUpdateReference && this.$Behaviors.updatesReference == 'serial');
    }
  },
  methods: {
    onRowClicked: function(option) { 
      this.$store.commit('setSelCat', option)
      this.fileName = option.file;
      this.catName = option.name
      this.selected = option.id.toString();
      this.catBrand = option.brand
    },
    manuallyOpenedCallback: function(){
      // non ha senso non passare dalla scelta catalogo se non ho nemmenno da scegliere la validità
      if(this.list.length == 1 && this.$Behaviors.loadCatalogIfOne && this.step7){
        this.selected = this.list[0].id.toString();
        this.fileName = this.list[0].file;
        this.catName = this.list[0].name;
        this.forward();
      } 
    },
    load: function() {
      if (this.selected.ID != null) {
        this.selected = this.selected.ID;
      }
      
      if(this.catBrand){
        this.$root
          .microservice({
              role: "authentication",
              cmd: "GetBrand",
              params: {
                  brandCod: this.catBrand
              }
          })
          .then(response => {   
            //salvo le info del brand in brandObj ma se ricarico la pagina perdo le info quindi le salvo anche nel localStorage 
            this.$root.brandObj = response ? response.body : {}
            if(response && response.body)localStorage.setItem('brand', JSON.stringify(response.body))
            //this.$root.setCustomCss();
          })
          .catch(err => {
            console.log(err);
            var msg = err && err.body && err.body.error ? err.body.error : ''
            eventBus.$emit('alert', {
              message: "Application caught an error <br> <h5>Details: " + "authentication.GetBrand - " + msg +'</h5>',
              type: "error",
              action: ''
            })
          })
      }

      var parameters = {};
      //TODO: check filename: al secondo caricamento del catalogo tramite wizard, la riga del catalogo è già selezionata
      //se non la riclicco e clicco subito Load arriva qui e filename è undefined!!!
      //con questo assegnamento si risolve il problema:
      this.fileName = !this.fileName ? this.$store.getters.getSelCat.file : this.fileName
      parameters.override = { catalogo: this.selected, nomeCatalogo: this.catName, modello: null, categoria: null, fileName: this.fileName, descrizioneModello: null };
      parameters.functionName = "load";
      this.$emit("forward", parameters);
    },
    initStep: function(array) {
      this.list = array;
      
      this.loading = false;
    },
    loadSub: function() {
      this.forward(true);
    },
    forward: function(sub) {
      if (this.selected.ID != null) {
        this.selected = this.selected.ID;
      }

      var parameters = { step: sub == true ? 6 : 7 };
      parameters.override = { catalogo: this.selected, nomeCatalogo: this.catName, modello: null, categoria: null, fileName: this.fileName, descrizioneModello: null };
      this.$emit("forward", parameters);
    },
    getDynTableElement: function(){
      var element = document.getElementById(this.selected); 
      if(element)element.scrollIntoView(true);
    }
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/components/loader/steps/SelezioneCatalogo.vue?0c1357b0